import { ToolbarButton } from '../ToolbarButton'
import { CopyRight2 } from 'blaze-ui/icons'
import { useActions } from 'components/VisualStudioPlayground/VisualEditor/hooks/useActions'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

type Props = {
  withText?: boolean
}

const CopyButton = ({ withText = true }: Props) => {
  const actions = useActions()
  const { isMobile } = useResponsiveDesign()
  const showCopyButton = !isMobile

  if (!showCopyButton) return null

  return (
    <ToolbarButton title="Copy" frontIcon={CopyRight2} onPress={() => actions.copy.onSelect()}>
      {withText && 'Copy'}
    </ToolbarButton>
  )
}

export { CopyButton }
